import type { PlaceDetail } from 'src/app/types';

function zipFromAddress(formattedAddress: string): string {
  const addressParts = formattedAddress.split(' ');
  const zipCode = addressParts[addressParts.length - 1];
  return zipCode;
}

export function sortSearchResultsByZip(results: PlaceDetail[], zipCode?: string): PlaceDetail[] {
  if (zipCode) {
    results.sort((a, b) => {
      const zipA = zipFromAddress(a.formatted_address);
      const zipB = zipFromAddress(b.formatted_address);

      // find how far an entry is from the entered zip by comparing zipCodes numerically
      const aDistance = Math.abs(parseInt(zipA, 10) - parseInt(zipCode, 10));
      const bDistance = Math.abs(parseInt(zipB, 10) - parseInt(zipCode, 10));
      // sort by how close the zipCode values are, smallest distance, i.e. matching zips, first
      return aDistance - bDistance;
    });
  }
  return results;
}
